exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-fd15f962] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-fd15f962] {\n  width: 100%;\n}\n.h2_title[data-v-fd15f962] {\n  text-align: left;\n  color: grey;\n}\n.btn-grabar[data-v-fd15f962] {\n  background-color: #ff6c00 !important;\n}\n", ""]);

// exports
